import { Box } from '@material-ui/core';
import format from 'date-fns/format';
import { getAge } from '../../../functions';
import { useSubheaderStyles } from '../../../assets/styles/Report.css';

/**
 *
 *
 *
 * @method Interface
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
type Props = {
  startTime: string;
  endTime: string;
  name: string;
  birthday: string;

  alertValue: number;
  alertName: string;

  projectName: string;
  organizationName: string;
  worksiteName: string;
  devices: string;
};

/**
 *
 *
 *
 * @method Component
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
const ReportSubHeaderWorkerDaily = (props: Props) => {
  const {
    startTime,
    endTime,
    name,
    birthday,
    alertValue,
    alertName,
    projectName,
    organizationName,
    worksiteName,
    devices,
  } = props;
  const classes = useSubheaderStyles();

  const startDate = startTime ? new Date(startTime) : null;
  const endDate = endTime ? new Date(endTime) : null;
  const isTomorrow = startDate?.getDay() !== endDate?.getDay();
  return (
    <div className={classes.container}>
      <Box display="flex" alignItems="center">
        <Box className={classes.cellLarge}>
          {startDate && format(startDate, 'yyyy年MM月dd日 HH時mm分')}~
          {isTomorrow ? '24時00分' : endDate && format(new Date(endTime), 'HH時mm分')}
        </Box>
        <Box className={classes.cellJoin}>の</Box>
        <Box className={classes.cellLarge}>{name}</Box>
        <Box>({birthday && startTime && getAge(birthday, startTime)}歳)</Box>
      </Box>

      <Box display="flex" alignItems="center">
        <Box className={classes.cellJoin}>ー</Box>
        <Box className={classes.cellSmall}>
          アラート設定値 {alertValue} : {alertName}
        </Box>
      </Box>

      <Box display="flex" alignItems="center">
        <Box className={classes.cellImage}>
          <img src="/images/report/pin.svg" alt={projectName} />
        </Box>
        <Box className={classes.cellSmall}>
          {projectName} / {organizationName}
        </Box>
        <Box className={classes.cellImage}>
          <img src="/images/report/map.svg" alt={worksiteName} />
        </Box>
        <Box className={classes.cellSmall}>{worksiteName}</Box>
      </Box>

      <Box display="flex" alignItems="center">
        <Box className={classes.cellImage}>
          <img src="/images/report/helmet.svg" alt={devices} />
        </Box>
        <Box className={classes.cellSmall}>{devices}</Box>
      </Box>
    </div>
  );
};

export default ReportSubHeaderWorkerDaily;
